const BENCHMARK = 'Benchmark'
const CONTRACT = 'Vertrag'
const DASHBOARD = 'Dashboard'
const DATAPOINT = 'Datenpunkt'
const FOLDER = 'Gebäude'
const NEWS = 'News'
const NOTIFICATION = 'Benachrichtigung'
const PANEL = 'Panel'
const PRICE = 'Preis'
const SENSOR = 'Sensor'
const SENSORFACTOR = 'Faktor'
const USER = 'Benutzer'

const DELETED = 'gelöscht'
const ID_REQUIRED = 'ID erforderlich'
const MOVED = 'verschoben'
const NAME_REQUIRED = 'Name erforderlich'
const SAVED = 'gespeichert'
const SENSOR_REQUIRED = 'Sensor erforderlich'
const UPDATED = 'aktualisiert'

export const languageConstants = {
  // BENCHMARK
  BENCHMARK_DELETED: `${BENCHMARK} ${DELETED}`,
  BENCHMARK_ID_REQUIRED: `${BENCHMARK} ${ID_REQUIRED}`,
  BENCHMARK_NAME_REQUIRED: `${BENCHMARK} ${NAME_REQUIRED}`,
  BENCHMARK_SAVED: `${BENCHMARK} ${SAVED}`,
  BENCHMARK_UPDATED: `${BENCHMARK} ${UPDATED}`,

  // CONTRACT
  CONTRACT_DELETED: `${CONTRACT} ${DELETED}`,
  CONTRACT_ID_REQUIRED: `${CONTRACT}s ${ID_REQUIRED}`,
  CONTRACT_NAME_REQUIRED: 'Name und Beschreibung erforderlich',
  CONTRACT_SAVED: `${CONTRACT} ${SAVED}`,
  CONTRACT_UPDATED: `${CONTRACT} ${UPDATED}`,

  // DASHBOARD
  DASHBOARD_DELETED: `${DASHBOARD} ${DELETED}`,
  DASHBOARD_ID_REQUIRED: `${DASHBOARD} ${ID_REQUIRED}`,
  DASHBOARD_NAME_REQUIRED: `${DASHBOARD} ${NAME_REQUIRED}`,
  DASHBOARD_SAVED: `${DASHBOARD} ${SAVED}`,
  DASHBOARD_UPDATED: `${DASHBOARD} ${UPDATED}`,

  // DATAPOINT
  DATAPOINT_DELETED: `${DATAPOINT} ${DELETED}`,
  DATAPOINT_ID_REQUIRED: `${DATAPOINT} ${ID_REQUIRED}`,
  DATAPOINT_NAME_REQUIRED: `${DATAPOINT} ${NAME_REQUIRED}`,
  DATAPOINT_SAVED: `${DATAPOINT} ${SAVED}`,
  DATAPOINT_UPDATED: `${DATAPOINT} ${UPDATED}`,

  // FOLDER
  FOLDER_DELETED: `${FOLDER} ${DELETED}`,
  FOLDER_ID_REQUIRED: `${FOLDER} ${ID_REQUIRED}`,
  FOLDER_NAME_REQUIRED: `${FOLDER} ${NAME_REQUIRED}`,
  FOLDER_SAVED: `${FOLDER} ${SAVED}`,
  FOLDER_UPDATED: `${FOLDER} ${UPDATED}`,

  // FOLDERTYPE
  FOLDERTYPE_ANY: '',
  FOLDERTYPE_DEFAULT: `${FOLDER}`,
  FOLDERTYPE_SUB: 'Untergebäude',

  // MISSING SENSORDATA
  MISSING_SENSORDATA_ERROR: 'Fehlende Sensor Daten Fehler',
  MISSING_SENSORDATA_REQUEST: 'Fehlende Sensor Daten Anfrage',
  MISSING_SENSORDATA_SUCCESS: 'Fehlende Sensor Daten gespeichert',

  // NEWS
  NEWS_CONTENT_REQUIRED: 'Titel und Inhalt erforderlich',
  NEWS_DELETED: `${NEWS} ${DELETED}`,
  NEWS_FOLDER_REQUIRED: 'Gebäude oder Vertrag erforderlich',
  NEWS_ID_REQUIRED: `${NEWS} ${ID_REQUIRED}`,
  NEWS_SAVED: `${NEWS} ${SAVED}`,
  NEWS_UPDATED: `${NEWS} ${UPDATED}`,

  // NEWSCATEGORY
  NEWSCATEGORY_ALL: '',
  NEWSCATEGORY_CONTRACT: `${CONTRACT}`,
  NEWSCATEGORY_OBJECT: `${FOLDER}`,

  // NEWSTYPE
  NEWSTYPE_ANY: '',
  NEWSTYPE_BUSINESS: 'kaufmännisch',
  NEWSTYPE_LEGAL: 'rechtlich',
  NEWSTYPE_TECH: 'technisch',

  // NOTIFICATION
  NOTIFICATION_DELETED: `${NOTIFICATION} ${DELETED}`,
  NOTIFICATION_FOLDER_REQUIRED: `${FOLDER} erforderlich`,
  NOTIFICATION_ID_REQUIRED: `${NOTIFICATION} ${ID_REQUIRED}`,
  NOTIFICATION_SAVED: `${NOTIFICATION} ${SAVED}`,

  // PANEL
  PANEL_DELETED: `${PANEL} ${DELETED}`,
  PANEL_ID_REQUIRED: `${PANEL} ${ID_REQUIRED}`,
  PANEL_MOVED: `${PANEL} ${MOVED}`,
  PANEL_NAME_REQUIRED: `${PANEL} ${NAME_REQUIRED}`,
  PANEL_SAVED: `${PANEL} ${SAVED}`,
  PANEL_SENSORS_REQUIRED: `${PANEL} Sensoren erforderlich`,
  PANEL_UPDATED: `${PANEL} ${UPDATED}`,

  // PRICE
  PRICE_ID_REQUIRED: `${PRICE} ${ID_REQUIRED}`,
  PRICE_SENSOR_REQUIRED: `${PRICE} ${SENSOR_REQUIRED}`,
  PRICE_DELETED: `${PRICE} ${DELETED}`,
  PRICE_SAVED: `${PRICE} ${SAVED}`,
  PRICE_UPDATED: `${PRICE} ${UPDATED}`,

  // SENSOR
  SENSOR_DELETED: `${SENSOR} ${DELETED}`,
  SENSOR_DEVICE_REQUIRED: 'Name und Device erforderlich',
  SENSOR_SAVED: `${SENSOR} ${SAVED}`,
  SENSOR_UPDATED: `${SENSOR} ${UPDATED}`,

  // FACTOR
  FACTOR_DELETED: `${SENSORFACTOR} ${DELETED}`,
  FACTOR_ID_REQUIRED: `${SENSORFACTOR} ${ID_REQUIRED}`,
  FACTOR_SAVED: `${SENSORFACTOR} ${SAVED}`,
  FACTOR_SENSOR_REQUIRED: `${SENSORFACTOR} ${SENSOR_REQUIRED}`,
  FACTOR_UPDATED: `${SENSORFACTOR} ${UPDATED}`,

  // USER
  USER_CODE_SENT: 'Code gesendet',
  USER_DELETED: `${USER} ${DELETED}`,
  USER_ID_REQUIRED: `${USER} ${ID_REQUIRED}`,
  USER_MAIL_SENT: 'E-Mail gesendet',
  USER_PASSWORD_CHANGED: `Passwort ${UPDATED}`,
  USER_REGISTRATION_SUCCESS: 'Registrierung erfolgreich',
  USER_SAVED: `${USER} ${SAVED}`,
  USER_UPDATED: `${USER} ${UPDATED}`,

  // USERROLE
  USERROLE_ANY: '',
  USERROLE_ADMIN: 'Admin',
  USERROLE_COACH: 'Coach',
  USERROLE_USER: 'Benutzer',
  USERROLE_GUEST: 'Gast',

  // USERSTATUS
  USERSTATUS_ANY: '',
  USERSTATUS_ACTIVE: 'aktiv',
  USERSTATUS_INACTIVE: 'inaktiv',
  USERSTATUS_NOT_CONFIRMED: 'unbestätigt',

  // VIRTUAL_SENSOR
  VIRTUAL_SENSOR_ID_REQUIRED: `Virtuelle ${ID_REQUIRED}`,
  VIRTUAL_SENSOR_SENSOR_REQUIRED: `Virtueller ${SENSOR_REQUIRED}`,
  VIRTUAL_SENSOR_DELETED: `Virtueller Sensor ${DELETED}`,
  VIRTUAL_SENSOR_SAVED: `Virtueller Sensor ${SAVED}`,
  VIRTUAL_SENSOR_UPDATED: `Virtueller Sensor ${UPDATED}`,
}
